import { Box, BoxProps } from '@mui/material';
import { forwardRef, PropsWithChildren } from 'react';

interface IBlurredBox extends PropsWithChildren, BoxProps {}

export const BlurredBox = forwardRef<any, IBlurredBox>(
  ({ children, sx = {}, ...others }, ref) => {
    return (
      <Box
        ref={ref}
        {...others}
        sx={{
          backgroundColor: 'background.paper',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(255, 255, 255, 0.10)',
          ...sx,
        }}
      >
        {children}
      </Box>
    );
  },
);
